import React, { useContext, useMemo } from "react";
import { useLocation } from "react-router-dom";
import HeaderWeb from "../Components/Header/header-web";
import { HeaderMobile } from "../Components/Header/header-mobile";
import { viewportSizeContext } from "../../context/viewport-size-context";
import "../Components/Header/header.css";

export default function Navbar() {
  const location = useLocation();
  const isMobile = useContext(viewportSizeContext);
  const currentPage = useMemo(() => {
    if (location.pathname === "/contact") return "Contact Us";
    if (location.pathname === "/about-us") return "About Us";
    if (
      ["/download", "/scripts"].some((p) => location.pathname.startsWith(p))
    ) {
      return "Scripts";
    }
    return "Home";
  }, [location]);

  if (isMobile) {
    if (currentPage === "All Reports") return <></>;

    return <HeaderMobile currentPage={currentPage} />;
  }

  return <HeaderWeb currentPage={currentPage} />;
}
